import { ChangeEvent, FC, useState } from "react";
import { Button, Drawer, Flex, Input, LegacyForm, Typography } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { ValidMobileNumber } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { DashboardRoutes } from "@/router";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalPhoneNumber: FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = LegacyForm.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);
  const phoneNumberApi = useAppSelector((state) => state.user.personalInfo?.phoneNumber);

  const [phoneNumber, setPhoneNumber] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("phoneNumber")}`}
        size={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.birthDate.url,
                fieldName: "phoneNumber",
                fieldValue: phoneNumber,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ phoneNumber: mobileFormEditState.phoneNumber ?? phoneNumberApi }}
          >
            <LegacyForm.Item
              name="phoneNumber"
              rules={[
                () => ({
                  validator(_, value) {
                    if (ValidMobileNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("profile.validPhoneNumber")));
                  },
                }),
                { required: true },
              ]}
            >
              <Input
                value={phoneNumber}
                placeholder={t("mobileEditPersonal.enterField", { fieldName: t("common.phoneNumber") })}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value)}
                disabled={isPersonalDisable()}
              />
            </LegacyForm.Item>
          </LegacyForm>

          <Typography.Text type={"secondary"}>
            {t("settings.personal.instructions.nationalIdAndBirthdatePhoneNumber")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalPhoneNumber;
